import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import { BusinessModelContent } from './api.graphql';
import type { BusinessModelContentQuery, BusinessModelContentQueryVariables } from './api.graphql';

export type BusinessModelPageData = NonNullable<BusinessModelContentQuery['businessModelContent']>;

export async function getBusinessPageData(
	{ gql: { fetch } }: UtilityContext,
	{ countryCode, locale }: { countryCode: string; locale: string },
): Promise<BusinessModelPageData> {
	const { data } = await fetch<BusinessModelContentQuery, BusinessModelContentQueryVariables>({
		query: BusinessModelContent,
		variables: {
			countryCode,
			locale,
		},
		rejectOnError: true,
	});
	if (!data.businessModelContent) {
		throw new NotFoundError();
	}
	return data.businessModelContent;
}
